var exports = {
  "Tp": "xcc377c0b--53e1c3--background",
  "kA": "xcc377c0b--53e1c3--icon-container",
  "DY": "xcc377c0b--53e1c3--click-area",
  "Lj": "xcc377c0b--53e1c3--click-area--hidden",
  "IT": "xcc377c0b--53e1c3--click-area--left",
};

module.exports = exports;
